var isLandscape=function(){return window.matchMedia("(orientation: landscape)").matches};export default isLandscape;
//# sourceMappingURL=isLandscape.js.map